export default __webpack_public_path__ + "static/img2-01022bad8eea78ffe57f17b39b04fe2c.png";